import Styles from './Carousels.module.scss'
import { SectionHeader } from './SectionHeader'
import { MediaFileCarousel } from './MediaFileCarousel'
import { getVideoMimeType } from 'components/Design/UploadsTab/components/StockVideosGallery'
import { MobileWizard } from 'components/Wizards/MobileWizards/Layout'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { StockVideosDrawer } from '../Grids/StockVideosDrawer'
import { useMediaPickerContext } from '../MediaPickerContext'
import { useStockVideos } from 'hooks/queries/designer/useStockVideos'

const title = 'Stock Videos'

export const StockVideos = observer(() => {
  const { openDrawer } = useRootStore().drawersStore
  const { handleSelect } = useMediaPickerContext()
  const stockVideosQuery = useStockVideos({
    query: '',
    pageSize: 6,
    videoType: 'all',
  })

  const videos = stockVideosQuery.data?.pages.flatMap((page) => page.videos) || []

  if ((stockVideosQuery.isFetched && videos.length === 0) || stockVideosQuery.isError) {
    return null
  }

  const files = videos.map((video) => ({
    id: video.id,
    source_url: video.videos.medium.url,
    duration: video.duration,
    variants: [],
    mime_type: video.videos.medium.mime_type ?? getVideoMimeType(video.videos.medium.url),
    title: video.id,
    thumbnail_url: video.videos.medium.thumbnail,
  }))

  const openStockVideosDrawer = () => {
    openDrawer(StockVideosDrawer, { title, onSelect: handleSelect })
  }

  return (
    <MobileWizard.Section gap={8}>
      <SectionHeader title={title} onPress={openStockVideosDrawer} />
      <div className={Styles.sectionContainer}>
        <MediaFileCarousel
          mediaFiles={files}
          isLoading={!stockVideosQuery.isFetched}
          needsDownload
          provider="stockVideo"
        />
      </div>
    </MobileWizard.Section>
  )
})
